<template>
  <div class="BasicLayout">
    <div class="suspension">
      <div class="suspension-item code">
        <img :src="suspension1" alt="">
        <div style="text-align: center;">{{ t('basicLayout.div1') }}</div>
        <div class="suspension-code">
          <div class="content">
            <img class="right" :src="right" alt="">
            <img class="code" :src="qrcode" alt="">
            <div style="text-align: center;">{{ t('basicLayout.div2') }}</div>
          </div>
        </div>
      </div>
      <div class="suspension-item email">
        <img :src="suspension2" alt="">
        <div style="text-align: center;">{{ t('basicLayout.div3') }}</div>
        <div class="suspension-email">
          <div class="content">
            <img class="right" :src="right" alt="">
            <div>{{ t('basicLayout.div3') }}</div>
            <div style="word-break: break-word; text-align: center;">ielts_xzlink@foxmail.com</div>
          </div>
        </div>
      </div>
    </div>

    <header ><header-box /></header>

    <div class="BasicLayout-view">
      <div class="BasicLayout-view-content" :style="style">
        <router-view></router-view>
      </div>
    </div>

    <footer><footer-box /></footer>
  </div>
</template>

<script setup>
  import { ref, watch } from 'vue';
  import { useRouter } from 'vue-router';
  import headerBox from './components/headerBox.vue';
  import footerBox from './components/footerBox.vue';
  import suspension1 from '../assets/header/suspension1.png';
  import suspension2 from '../assets/header/suspension2.png';
  import right from '../assets/header/right.png';
  import qrcode from '../assets/AboutUs/qrcode.png';
  import i18n from '../locale/i18n';

  const t = (key) => i18n.global.t(key);
  const router = useRouter();
  const style = ref('background: rgba(223, 238, 254, 1);');

  watch(
    () => router.currentRoute.value.path,
    (newPath) => {
      style.value = newPath === '/dashboard'
        ? 'background: rgba(247, 251, 255, 1);'
        : 'background: rgba(223, 238, 254, 1);';
    },
    { immediate: true }
  );
</script>

<style lang="less" scoped>
  /* 悬浮按钮样式 */
  .suspension {
    z-index: 50;
    position: fixed;
    top: 50%;
    right: 10px;
    width: 3.5rem;
    height: 7rem;
    border-radius: 0.5rem;
    background: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .suspension-item {
      cursor: pointer;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 0.8rem;
      color: #333;

      img {
        width: 1.2rem;
        height: auto;
        margin-bottom: 0.3rem;
      }
    }

    .code:hover .suspension-code,
    .email:hover .suspension-email {
      display: block;
    }

    .suspension-code, .suspension-email {
      display: none;
      position: fixed;
      right: 4.5rem;
      background: #fff;
      border-radius: 0.5rem;
      z-index: 50;
      padding: 0.2rem;

      .content {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 0.7rem;
        color: #000;
        text-align: center;

        .right {
          position: absolute;
          top: 50%;
          right: -0.5rem;
          width: 0.9rem;
          height: 0.9rem;
        }

        .code {
          width: 5rem;
          height: 5rem;
          margin-bottom: 0.3rem;
        }
      }
    }
  }

  /* 页面布局 */
  .BasicLayout {
    background-color: #fff;
    flex: 1;
    display: flex;
    flex-direction: column;

    .BasicLayout-view {
      flex: 1;
      // padding-top: 2rem;
      padding-top: 4.36vw;

      .BasicLayout-view-content {
        height: 100%;
        padding-bottom: 5rem;
      }
    }
  }

  /* 移动端适配 */
  @media (max-width: 768px) {
    .suspension {
      width: 3rem;
      height: 6rem;
      right: 5px;
    }

    .suspension-item {
      font-size: 0.7rem;

      img {
        width: 1rem;
      }
    }

    .suspension-code, .suspension-email {
      right: 3.5rem;
      width: 5rem;
    }

    .suspension-code .content,
    .suspension-email .content {
      font-size: 0.6rem;
    }

    .BasicLayout-view {
      padding-top: 4.36vw;
    }
  }
</style>
